

import React from 'react'

export default props => (
  <svg {...props} width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      className="stroke"
      x="3"
      y="6"
      width="26"
      height="20"
      rx="5"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      className="stroke"
      d="M8 11L11.2 13.4C13.5111 15.1333 14.6667 16 16 16C17.3333 16 18.4889 15.1333 20.8 13.4L24 11"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
